import { Link } from '@tanstack/react-router';
import { Button, Stack, Text } from '@fragments-sdk/ui';

interface ErrorPageProps {
  /** Large display code, e.g. "404" or "500" */
  code: string;
  /** Short heading */
  title: string;
  /** Descriptive text */
  description: string;
  /** Optional Sentry error ID for support reference */
  errorId?: string;
  /** Show "Try again" button (for 500-style errors) */
  showRetry?: boolean;
}

export function ErrorPage({
  code,
  title,
  description,
  errorId,
  showRetry,
}: ErrorPageProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '48px 24px',
        background: 'var(--fui-bg-primary)',
        color: 'var(--fui-text-primary)',
      }}
    >
      <Stack
        gap="lg"
        align="center"
        style={{ maxWidth: 480, textAlign: 'center' }}
      >
        <Text
          size="xl"
          weight="bold"
          style={{ fontSize: '72px', lineHeight: 1, letterSpacing: '-0.02em' }}
        >
          {code}
        </Text>

        <Stack gap="sm" align="center">
          <Text size="lg" weight="semibold">
            {title}
          </Text>
          <Text size="md" color="secondary">
            {description}
          </Text>
        </Stack>

        <Stack direction="row" gap="sm">
          {showRetry && (
            <Button variant="outline" onClick={() => window.location.reload()}>
              Try again
            </Button>
          )}
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Button variant="primary">Go to Dashboard</Button>
          </Link>
        </Stack>

        {errorId && (
          <Text size="xs" color="secondary" font="mono">
            Error ID: {errorId}
          </Text>
        )}
      </Stack>
    </div>
  );
}
